import React, { useMemo } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Button,
} from "reactstrap"
import { useTranslation } from "react-i18next"
import CustomLabel from "components/Common/CustomLabel"

const EvaluationResultModal = ({ isOpen, toggle, data }) => {
  const { t } = useTranslation()

  // Utility to convert numeric answer to "Yes"/"No"
  const getAnswerText = answer => (answer === 1 ? t("Yes") : t("No"))

  const showMarks = useMemo(() => {
    return data?.data?.some(item => item.mark !== null)
  }, [data])

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{t("Evaluation Result")}</ModalHeader>

      <ModalBody>
        {data.comment && (
          <div className="my-2">
            <h5 className="text-primary font-bold"> {t("Comment")}</h5>
            <p>{data?.comment}</p>
          </div>
        )}

        <Table bordered>
          <thead>
            <tr>
              <th>{t("No.")}</th>
              <th>{t("Question")}</th>
              <th>{showMarks ? t("Marks") : t("Answer")}</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.map((item, index) => (
              <tr key={item.id}>
                {<td> {item.question.is_main_section ? "" : index + 1} </td>}
                <td
                  style={{
                    fontWeight: item.question.is_main_section ? "bold" : "",
                    textAlign: item.question.is_main_section
                      ? "center"
                      : "start",
                  }}
                >
                  {item.question.question || `${t("Section Result")}`}
                </td>
                <td
                  style={{
                    fontWeight: item.question.is_main_section ? "bold" : "",
                  }}
                >
                  {item.answer !== null
                    ? getAnswerText(item.answer)
                    : item.mark}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          {t("Close")}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default EvaluationResultModal
